export default __webpack_public_path__ + "static/lgbtq-pr-sj-6-7dee13fc276310307ae2fe02b75b95bf.jpg";